import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, concatMap, switchMap, tap } from "rxjs/operators";
import { AnalyticsService } from "@serasa/shared/services/analytics.service";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";

import { DashboardService } from "../../services/dashboard.service";

import * as DashboardActions from "../actions/dashboard.actions";
import * as UserActions from "../../../users/state/actions/user.actions";

@Injectable()
export class DashboardEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly _dashboardService: DashboardService,
    private readonly _analyticsService: AnalyticsService,
  ) { }

  loadBlockUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadBlockUser),
      concatMap((action) =>
        this._dashboardService.blockUser(action.payload).pipe(
          concatMap((_) =>
            of(
              DashboardActions.loadBlockUserSuccess({
                response: { success: true },
              }),
            ).pipe(
              tap(() => {
                this._analyticsService.doCustomEvent(
                  {
                    events: ["portalLogons_BloqueioLogonSucesso"],
                    flowName: "MP:LG:IN:PortalDeLogons:BloquearUsuarioSucesso",
                  },
                  "PortalDeLogonsBloquearUsuarioSucesso",
                );
              }),
            ),
          ),
          catchError((error: HttpErrorResponse) =>
            of(DashboardActions.loadBlockUserFailure({ error })).pipe(
              tap((error) => {
                this._analyticsService.sendCustomError(
                  error.error,
                  SiteSection.ERRO_AO_BLOQUEAR_USUARIO,
                  "POST",
                );
              }),
            ),
          ),
        ),
      ),
    );
  });

  loadUnblockUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadUnblockUser),
      concatMap((action) =>
        this._dashboardService.unblockUser(action.payload).pipe(
          concatMap((_) =>
            of(
              DashboardActions.loadUnblockUserSuccess({
                response: { success: true },
              }),
            ).pipe(
              tap(() => {
                this._analyticsService.doCustomEvent(
                  {
                    events: ["portalLogons_DesbloqueioLogonSucesso"],
                    flowName:
                      "MP:LG:IN:PortalDeLogons:DesbloquearUsuarioSucesso",
                  },
                  "PortalDeLogonsDesbloquearUsuarioSucesso",
                );
              }),
            ),
          ),
          catchError((error: HttpErrorResponse) =>
            of(DashboardActions.loadUnblockUserFailure({ error })).pipe(
              tap((error) => {
                this._analyticsService.sendCustomError(
                  error.error,
                  SiteSection.ERRO_AO_DESBLOQUEAR_USUARIO,
                  "POST",
                );
              }),
            ),
          ),
        ),
      ),
    );
  });

  resetBlockUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadResetBlockUser),
      switchMap((action) =>
        of(
          UserActions.loadLogonsList({
            offset:
              JSON.parse(
                localStorage.getItem("mat-paginator") ||
                  ('{"pageIndex":0}' as string),
              ).pageIndex || 0,
            isPagination: false,
            limit: 20,
          }),
        ),
      ),
    );
  });

  loadDeleteUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DashboardActions.loadDeleteUser),
      concatMap((action) =>
        this._dashboardService.deleteUser(action?.logon as string).pipe(
          concatMap((_) =>
            of(
              DashboardActions.loadDeleteUserSuccess({ success: true }),
            ).pipe(
              tap(() => {
                this._analyticsService.doCustomEvent(
                  {
                    events: ["portalLogons_DeletarLogonSucesso"],
                    flowName: "MP:LG:IN:PortalDeLogons:DeletarUsuarioSucesso",
                  },
                  "PortalDeLogonsDeletarUsuarioSucesso",
                );
              }),
            ),
          ),
          catchError((error: HttpErrorResponse) =>
            of(DashboardActions.loadDeleteUserFailure({ logon: action.logon as string, error })).pipe(
              tap((error) => {
                this._analyticsService.sendCustomError(
                  error.error,
                  SiteSection.ERRO_AO_BLOQUEAR_USUARIO,
                  "DELETE",
                );
              }),
            ),
          ),
        ),
      ),
    );
  });

}
